import * as React from 'react';
import { useParams } from 'react-router';

import { Panel, RepeatingSection, Field, InputField, useForm } from 'app2/components';
import { useSiteAccountingCodesQuery } from 'app2/views/shared';

import { SiteRouteParams } from '../organizerRoutes';
import { organizerUpdateAccountingCodes } from './gql';

export function AccountingCodes() {
  const { site: siteId } = useParams<SiteRouteParams>();
  const [result] = useSiteAccountingCodesQuery({ variables: { site: siteId } });

  const form = useForm({ accountingCodes: result.data?.site?.accountingCodes }, [siteId, result]);

  async function onOk() {
    const variables = { siteId, accountingCodes: form.values.accountingCodes };
    const [success] = await organizerUpdateAccountingCodes({ variables, successMsg: 'Accounting codes updated successfully.', error: form });

    return success;
  }

  return <Panel icon='FileText' title='Accounting codes' type='toggle' form={form} onOk={onOk}>
    <RepeatingSection name='accountingCodes' add='Add accounting code' fields={[
      <Field label='Code' name='code' component={InputField} required />,
      <Field label='Label' name='label' component={InputField} required />,
      'remove'
    ]} />
  </Panel>;
}
